import React, { PropsWithChildren } from "react";
import { SearchContextState } from "models/propTypes/reportsPropTypes";
import { ContextConstants } from "utils/constants";
import { SearchReducer } from "./reducer";

const initialState: SearchContextState = {
  setSearchText: () => {},
};

export const SearchContext = React.createContext<SearchContextState | undefined>(undefined);

const SearchContextProvider: React.FC<PropsWithChildren<{ initialSearchText?: string }>> = ({
  children,
  initialSearchText,
}) => {
  const [state, dispatch] = React.useReducer(SearchReducer, { ...initialState, searchText: initialSearchText });

  const setSearchText = (value?: string) => {
    if (value !== state.searchText) dispatch({ type: ContextConstants.SearchActions.SET_SEARCH_TEXT, payload: value });
  };

  return <SearchContext.Provider value={{ ...state, setSearchText }}>{children}</SearchContext.Provider>;
};

export default SearchContextProvider;
